import React from 'react';

/**
 * Empty state row for CDP Reports table
 * Displayed when no records match the current filters
 */
const EmptyTableRow = () => (
    <tr key='no results'>
        <td colSpan="4">No Record Found</td>
    </tr>
);

export default EmptyTableRow;
